import { render, staticRenderFns } from "./GSelect.vue?vue&type=template&id=6992baa6&scoped=true&"
import script from "./GSelect.vue?vue&type=script&lang=js&"
export * from "./GSelect.vue?vue&type=script&lang=js&"
import style0 from "./GSelect.vue?vue&type=style&index=0&id=6992baa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992baa6",
  null
  
)

export default component.exports